import React from "react";
import "./AboutBanner.css";
import personImg from "../Assets/about_person.png";
import overlayShape from "../Assets/Triangle.png";
import { motion } from "framer-motion";

const AboutBanner = () => {
  return (
    <section className="about-banner">
      {/* Left Content */}
      <motion.div
        className="banner-content"
        initial={{ x: -100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.h1
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
        >
          Fluent <span>English</span>, <br />
          <span>Simple</span> Steps
        </motion.h1>

        <motion.p
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut", delay: 0.4 }}
        >
          Master the Art of Confident Communication with <br />
          Our Online English Speaking Course
        </motion.p>

        <motion.div
          className="banner-buttons"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.6 }}
        >
          {/* CTA Button */}

          {/* Watch Button */}
        </motion.div>
      </motion.div>

      {/* Right Side Images */}
      <motion.div
        className="banner-images"
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
      >
        <motion.img
          src={overlayShape}
          alt="Decorative Triangle Overlay"
          loading="lazy"
          className="overlay-shape"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.7, delay: 0.7 }}
        />

        <motion.img
          src={personImg}
          alt="Student"
          loading="lazy"
          className="person-img"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.9, ease: "easeOut", delay: 1 }}
        />
      </motion.div>
    </section>
  );
};

export default AboutBanner;
